import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../../../services/shared';
import { REVENUE_RECOGNITION_TAG_TYPES } from './tags';

/**
 * Single base RTK Query API for the Accounts backend as this module reads it (one `createApi` per
 * backend per module).
 *
 * Intentionally EMPTY of endpoints — features inject their own via
 * `revenueRecognitionApi.injectEndpoints` in `features/{x}/data/{x}Endpoints.ts` (mirrors
 * `modules/claims/data/claimsApi.ts`). Never create a second `createApi` for this backend from
 * within this module. Import this base api by file path (`../../../data/revenueRecognitionApi`)
 * from feature endpoint files, not via the `data` barrel, to avoid import cycles.
 */
export const revenueRecognitionApi = createApi({
  reducerPath: 'revenueRecognitionApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.accounts),
  tagTypes: REVENUE_RECOGNITION_TAG_TYPES,
  endpoints: () => ({}),
});
